module.exports = __webpack_public_path__ + "static/img/logo4.a4195382.jpg";